import { GO_BOARD_GRID_END_LINE_INDEX, GO_BOARD_GRID_INSET_PERCENT, GO_BOARD_GRID_START_LINE_INDEX, GO_BOARD_PERCENT_MULTIPLIER } from "@/constants";
const getNearestGoBoardCoordinate = (clientX, clientY, boardRectangle) => {
  const gridInsetRatio = GO_BOARD_GRID_INSET_PERCENT / GO_BOARD_PERCENT_MULTIPLIER;
  const gridStartX = boardRectangle.left + boardRectangle.width * gridInsetRatio;
  const gridStartY = boardRectangle.top + boardRectangle.height * gridInsetRatio;
  const gridWidth = boardRectangle.width * (1 - gridInsetRatio - gridInsetRatio);
  const gridHeight = boardRectangle.height * (1 - gridInsetRatio - gridInsetRatio);
  const column = Math.round((clientX - gridStartX) / gridWidth * GO_BOARD_GRID_END_LINE_INDEX);
  const row = Math.round((clientY - gridStartY) / gridHeight * GO_BOARD_GRID_END_LINE_INDEX);
  return {
    column: Math.min(GO_BOARD_GRID_END_LINE_INDEX, Math.max(GO_BOARD_GRID_START_LINE_INDEX, column)),
    row: Math.min(GO_BOARD_GRID_END_LINE_INDEX, Math.max(GO_BOARD_GRID_START_LINE_INDEX, row))
  };
};
export { getNearestGoBoardCoordinate };